// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_p2-0";
export var discountCodeInput = "_p2-1";